import React from "react";
import PropTypes from "prop-types";
import CheckboxItem from "./FilterCheckboxItem";

const FilterSection = ({ id, title, items, onItemChange }) => (
	<section className="filters__section">
		<fieldset className="filters__fieldset">
			<legend className="filters__section-title">{title}</legend>
			{items.map((item) => (
				<CheckboxItem
					key={item.id}
					id={item.id}
					label={item.label}
					name={item.name}
					value={item.value}
					checked={item.checked}
					onChange={() => onItemChange(id, item.id)}
				/>
			))}
		</fieldset>
	</section>
);

FilterSection.propTypes = {
	id: PropTypes.string.isRequired,
	title: PropTypes.string.isRequired,
	items: PropTypes.arrayOf(
		PropTypes.shape({
			id: PropTypes.string.isRequired,
			label: PropTypes.string.isRequired,
			name: PropTypes.string.isRequired,
			value: PropTypes.string.isRequired,
			checked: PropTypes.bool
		})
	).isRequired,
	onItemChange: PropTypes.func.isRequired
};

export default FilterSection;
